import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export default function PatientDetailRouter() {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    async function loadAndRedirect() {
      if (!id) return;

      try {
        const ref = doc(db, 'patients', id);
        const snap = await getDoc(ref);

        if (!snap.exists()) {
          navigate('/dashboard', { replace: true });
          return;
        }

        const patient = snap.data();
        const setting = patient.setting || 'Inpatient';
        const navOptions = { replace: true };

        switch (setting) {
          case 'Inpatient':
            navigate(`/inpatient/${id}`, navOptions);
            break;
          case 'Emergency Room':
            navigate(`/ed/${id}`, navOptions);
            break;
          case 'Outpatient':
            navigate(`/outpatient/${id}`, navOptions);
            break;
          case 'Consult':
            navigate(`/consult/${id}`, navOptions);
            break;
          default:
            navigate(`/inpatient/${id}`, navOptions);
        }
      } catch (err) {
        navigate('/dashboard', { replace: true });
      }
    }

    loadAndRedirect();
  }, [id, navigate]);

  return (
    <div className="flex items-center justify-center h-screen bg-[#f4f7f9] dark:bg-black">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-700 dark:text-gray-200 text-lg">
          Routing to patient details...
        </p>
      </div>
    </div>
  );
}
